module.exports = __webpack_public_path__ + "static/media/The-Beauty-Hair-Saloon.f7f4daf1.png";